import { Switch } from '@components/index';
import { FormDataType } from '@types';

import MinPartialPaymentAmountInput from '../../v1/feeDetailsInput/MinPartialPaymentAmountInput';

interface CustomAmountSectionProps {
  formData: FormDataType;
  onCustomAmountEnabledChange: (enabled: boolean) => void;
  onMinPartialPaymentAmountChange: (value: string) => void;
}

const CustomAmountSection = ({
  formData,
  onCustomAmountEnabledChange,
  onMinPartialPaymentAmountChange
}: CustomAmountSectionProps) => (
  <div className="flex flex-col">
    <div className="flex items-start gap-2">
      <Switch
        handleClick={onCustomAmountEnabledChange}
        value={!!formData.paymentInstallment}
      />
      <div className="min-w-0 flex-1 pb-1">
        <span className="text-base font-semibold text-cofeeNeutral10">
          Enable custom / partial amount
        </span>
        <div className="text-sm text-cofeeNeutral7">
          Payers can choose to enter a custom amount or partial amount on the
          review page during payment.
        </div>
      </div>
    </div>
    {formData.paymentInstallment && (
      <MinPartialPaymentAmountInput
        formData={formData}
        onAmountChange={onMinPartialPaymentAmountChange}
      />
    )}
  </div>
);

export default CustomAmountSection;
